import { Observable } from "rxjs"
import { ObservableFromFetch } from "../../ObservableFromFetch"
import ImportJobData from "./Model/ImportJobData"

export default function ImportJobCreateObservable(csvBase64: string, fileName: string, companyID: number, importJobID?: number): Observable<ImportJobData> {
  const params: string = JSON.stringify({
    CSVFileBase64String: csvBase64,
    FileName: fileName,
    ImportJobID: importJobID || 0,
    CompanyID: companyID
  })
  return ObservableFromFetch<ImportJobData>("WorkforceCompanyImport/CreateImportJob", params)
}

export function LocationImportJobCreateObservable(csvBase64: string, fileName: string, implementationID: number, companyID: number, importJobID?: number): Observable<ImportJobData> {
  const params: string = JSON.stringify({
    CSVFileBase64String: csvBase64,
    FileName: fileName,
    ImportJobID: importJobID || 0,
    CompanyID: implementationID,
    AccountID: companyID,
    WorkforceLocation: true
  })
  return ObservableFromFetch<ImportJobData>("WorkforceCompanyImport/CreateImportJob", params)
}
